(function($) {
// TODO: Only import this on the one page it is used on
  $(function(){
    $('body').scrollspy({ target: '#timelineNav', offset: 200 });
  })

  $(window).on('activate.bs.scrollspy', function (e, obj) {
    const navItem = $('[href="' + obj.relatedTarget+ '"]')
    if (navItem.length <= 0) {
      return; // exit function if elem doesn't exist
    }
    const left = navItem.offset().left;
    const width = navItem.outerWidth();
    // Need div with :before:after
    // Change text of sed div to text of navitem
    // Have navitem have no indication of active change

    navItem.parent().parent().prev().css({
      left: left,
      width: width,
    }).fadeIn();

  })

  /**
     * Copyright 2012, Digital Fusion
     * Licensed under the MIT license.
     * http://teamdf.com/jquery-plugins/license/
     *
     * @author Sam Sehnert
     * @desc A small plugin that checks whether elements are within
     *     the user visible viewport of a web browser.
     *     only accounts for vertical position, not horizontal.
     */

  $.fn.visible = function(partial) {
      
    var $t            = $(this),
        $w            = $(window),
        viewTop       = $w.scrollTop(),
        viewBottom    = viewTop + $w.height(),
        _top          = $t.offset().top,
        _bottom       = _top + $t.height(),
        compareTop    = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;
    
    return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

  };


  $(window).scroll(function(event) {
    
    $(".timeline-visual, .timeline-content").each(function(i, el) {
      var el = $(el);
      if (el.visible(true)) {
        el.addClass("come-in"); 
      } 
    });
    
  });

  var win = $(window);
  var allMods = $(".timeline-visual, .timeline-content");

  // Already visible modules
  $(document).ready(function() {
    allMods.each(function(i, el) {
      var el = $(el);
      if (el.visible(true)) {
        el.addClass("come-in"); 
      } 
    });
  })

  win.scroll(function(event) {
    
    allMods.each(function(i, el) {
      var el = $(el);
      if (el.visible(true)) {
        el.addClass("come-in"); 
      } 
    });
    
  });

})(jQuery)